module.exports = __webpack_public_path__ + "static/media/TasklyWireframes.dc14273d.png";